import React__default from 'react';
import classNames from 'classnames';
import { createNvButtonClassNames, NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './FooterBlock.module.esm.js';

var FooterBlock = function (_a) {
    var _b = _a.fields, linkAppearance = _b.linkAppearance, body = _b.body, heading = _b.heading, link = _b.link;
    var hasContent = body || heading || link;
    if (!hasContent) {
        return null;
    }
    var buttonClassNames = createNvButtonClassNames(linkAppearance);
    return (React__default.createElement("div", { className: classNames(styles.footerBlock, 'nv-container') },
        heading && (React__default.createElement(NvMarkdownInline, { className: styles.heading, element: "h2", elementWrapper: NvHeading, level: 4 }, heading)),
        body && React__default.createElement(NvMarkdown, { className: styles.body }, body),
        link && React__default.createElement(BaseNucleobaseComponent, { classes: { link: buttonClassNames }, source: link })));
};

export { FooterBlock as default };
//# sourceMappingURL=FooterBlock.esm.js.map
